import React from 'react';

export const Tag = ({
	children,
	onRemove,
	variant = 'default',
	className = ''
}) => {
	const variantClass = variant !== 'default' ? `tag-${variant}` : '';

	return (
		<span className={`form-tag ${variantClass} ${className}`}>
			{children}
			{onRemove && (
				<span className="tag-remove" onClick={onRemove}>
					<img src="/ats/icons/close-blue-icon.svg" alt="Delete" />
				</span>
			)}
		</span>
	);
};

export const TagList = ({
	tags = [],
	onRemove,
	getTagVariant,
	textKey,
	className = ''
}) => {
	if (!tags || tags.length === 0) return null;

	return (
		<div className={`form-tags ${className}`}>
			{tags.map(tag => {
				const tagText =
					typeof tag === 'string' ? tag : tag[textKey] || tag.label;
				const variant = getTagVariant ? getTagVariant(tag) : 'default';

				return (
					<Tag
						key={tag.id}
						variant={variant}
						onRemove={onRemove ? () => onRemove(tag) : null}>
						{tagText}
					</Tag>
				);
			})}
		</div>
	);
};
